<template>
  <div class="home-main-left-login-success">
    <div class="log-out">
      <div class="log-out-btn theme-primary-text-color" @click="handleLogout">注销</div>
    </div>
    <div class="user-info">{{authorizeObj.loginId}}同学，你好！</div>
    <div class="welcome">欢迎报考{{schoolInfo.schoolName}}</div>
    <img class="banner" src="../../../assets/pages/homeIndex/login-success-banner.png">
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  name: 'HomeMainLeftLoginSuccess',
  computed: {
    ...mapState({
      authorizeObj: state => state.authorization.authorizeObj,
      schoolInfo: state => state.schoolInfo.schoolInfo
    })
  },
  methods: {
    ...mapActions(['logoutRequest']),
    handleLogout () {
      this.logoutRequest().then(response => {
        this.$message.success('用户注销成功')
      }, err => {
        this.$message.error(err.message || '用户注销失败')
      })
    }
  }
}
</script>

<style lang="scss">
.home-main-left-login-success {
  &>.log-out {
    display: flex;
    justify-content: flex-end;
    align-items: center;
     &>.log-out-btn {
       width: fit-content;
       font-size: 14px;
       font-weight: bold;
       cursor: pointer;
       margin-right: -5px;
     }
  }
  &>.user-info {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    margin: 30px 0 44px;
  }
  &>.welcome {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    text-align: right;
    padding-right: 30px;
  }
  &>.banner {
    display: block;
    margin-top: 100px;
    width: 100%;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/homeIndex/HomeMainLeftLoginSuccess.vue